import { render, staticRenderFns } from "./Combination.vue?vue&type=template&id=330f66b8&"
import script from "./Combination.vue?vue&type=script&lang=js&"
export * from "./Combination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330f66b8')) {
      api.createRecord('330f66b8', component.options)
    } else {
      api.reload('330f66b8', component.options)
    }
    module.hot.accept("./Combination.vue?vue&type=template&id=330f66b8&", function () {
      api.rerender('330f66b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/QuestionItem/Combination.vue"
export default component.exports